







































import Vue from 'vue';
import moment from "moment";
import {Component} from 'vue-property-decorator';
import Tabs from '@/components/Money/Tabs.vue';
import ChooseMonth from "@/components/Calendar/ChooseMonth.vue";
import clone from "@/lib/clone";
import { RecordItem, RootState } from './custom';
import EmptyData from "@/components/Money/EmptyData.vue";


type HashTableValue = { title: string, item:RecordItem[]}
type hashTable = { [key: string]: HashTableValue }

@Component({
  components: {EmptyData, ChooseMonth, Tabs}
})
export default class Reports extends Vue {
  month = ''
  beforeCreate() {
    this.$store.commit('fetchRecords')
  }
  get recordList() {
    return (this.$store.state as RootState).recordList;
  }

  get result() {
    const {recordList} = this;
    const totalTable: hashTable = {};
    //声明这个hashTable的key是字符串，value是HashTableValue类型
    const newList = clone(recordList).sort((a,b)=>moment(b.createdAt).valueOf()-moment(a.createdAt).valueOf())

    for (let i = 0; i < newList.length; i++) {
      const date = newList[i].createdAt!
      if(date.indexOf(this.month)> -1){
        totalTable[date] = totalTable[date] || {title: date, item: []}
        totalTable[date].item.push(newList[i])
      }
    }
    return totalTable
  }

  showTotal(group:HashTableValue){
    let total = 0
    let item:RecordItem
    for(item of group.item){
      if(item.type ==='expense') {
        total -= item.amount
      }
      else{
        total += item.amount
      }
    }
    if(total>0){
      return '+'+this.addComma(total)
    }else if(total<0){
      return '-'+this.addComma(total)
    }else{
      return '0'
    }
  }
  addComma(amount:number){
    return amount.toString().replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  showNote(item:RecordItem){
    if(item.notes!==''){
      return '('+item.notes+')'
    }
  }
  showAmount(item:RecordItem){
    let commaAmount = this.addComma(item.amount)
    if(item.type === 'income'){
      return '+'+commaAmount
    }else{
      return '-'+commaAmount
    }
  }
};
